import * as Yup from 'yup';

export const chatbotValidationSchema = Yup.object().shape({
  message: Yup.string().required('Please enter a message'),
});
